import React, { useState } from 'react';
import TotalSales from './TotalSales';
import './Report.css';
import '../../common/pillTabs.css';
import { Box } from '@mui/material';
import PopularProduct from './PopularProduct';

const Report = () => {
  

  const [activeComponent, setActiveComponent] = useState(0);

  const handleToggle = (index) => {
    setActiveComponent(index);
  };


  return (
    <>
      <Box sx={{ marginTop: 1, display: 'flex', justifyContent: 'start' }}>
        <div className="pill-box" style={{ width: '260px', maxWidth: '100%' }}>
          <div
            className="pill-slider"
            style={{
              left: `calc(5px + ${activeComponent} * (100% - 10px) / 2)`,
              width: 'calc((100% - 10px) / 2)',
            }}
          />
          <button className={`pill-btn ${activeComponent === 0 ? 'active' : ''}`} onClick={() => handleToggle(0)}>
            Total Sales
          </button>
          <button className={`pill-btn ${activeComponent === 1 ? 'active' : ''}`} onClick={() => handleToggle(1)}>
            Popular Product
          </button>
        </div>
      </Box>

      {activeComponent === 0 && <TotalSales />}
      {activeComponent === 1 && <PopularProduct />}
    </>
  );
};

export default Report;
